module.exports = __webpack_public_path__ + "img/about-yaara.67e25cfa.jpg";